angular.module('impactx.controlstructure').component('ixBasketControlStructure', {
        bindings:  {
            controlStructures: '<',
            trns: '<',
            saveBasket: '&?',
            checkRequire: '&',
            name: '@',
            helperDialogParams: "<",
            parentControlLabels: "<",
            basketControlLabels: "<",
            initShowAll: '<',
            fractionSize: "="
        },
        controller: 'BasketControlStructureCtrl',
        templateUrl: 'modules/control/templates/basket-control-structure.tmpl.html'
    }
);